import { atom, RecoilState } from "recoil";

export const trackingParamsState: RecoilState<Record<string, unknown> | null> = atom({
  key: "trackingParamsState",
  default: null,
});
